const Time = {
	new: function(hour, minutes) {
		let pm = hour >= 12;
		let mString = (minutes < 10 ? '0' + minutes: minutes).toString();
		let hString = (pm && hour !== 12 ? (hour - 12): hour).toString();
		let str = hString + ':' + mString;
		str += pm ? 'pm' : 'am';
		return this.parse(str, true);
	},

	parse: function(str) {
		let timeSpan = {hour: 0, minutes: 0};
		let range = str.match(/^(\d+):(\d\d)\s*(\w\w)$/);
		timeSpan.hour = parseInt(range[1], 10);
		timeSpan.minutes = parseInt(range[2], 10);
		timeSpan.value = str;
		
		if(range[3] === 'pm' && timeSpan.hour !== 12) {
			timeSpan.hour += 12;
		}
		timeSpan.totalMinutes = (timeSpan.hour * 60) + timeSpan.minutes;
		return timeSpan;
	},

	stringFromMinutes: function(minutes) {
		let hour = Math.floor(minutes / 60);
		minutes %= 60;
		return this.new(hour, minutes).value;
	},

	getId: function(str) {
		let timeSpan = this.parse(str);
		let hour = timeSpan.hour.toString();
		let minutes = timeSpan.minutes;
		if(timeSpan.minutes < 10) {
			minutes = '0' + minutes.toString();
		}
		return parseInt(hour.toString() + minutes.toString(), 10);
	},

	duration: function(startStr, endStr) {
		let start = this.parse(startStr);
		let end = this.parse(endStr);
		let hours = end.hour - start.hour;
		let minutes = end.minutes - start.minutes;
		let startMinutes;
		
		if(hours > 0) {
			minutes = hours * 60;
			if(minutes === 60) {
				minutes -= start.minutes;
				minutes += end.minutes;
			}
			else {
				startMinutes = (start.minutes !== 0 ? (60 - start.minutes) : 0);
				if(startMinutes + end.minutes !== 60 && startMinutes + end.minutes !== 0) {
					hours = (hours - 1) * 60;
					minutes = hours + startMinutes + end.minutes;
				}
			}
		}
		return {hours: minutes / 60, minutes: minutes};
	}
};

export default Time;


/** WEBPACK FOOTER **
 ** ./src/js/lib/time.js
 **/